<app-header ></app-header>
<div class="container pr-0 pl-0">
  <main class="row">
    <!-- <nav class="sidebar" [ngClass]="{'sidebar--mini': !navLarge  , 'sidebar-large':navLarge}"> -->
    <nav class="col-md-1 sidebar sidebar--mini">
      <app-sidebar (navToggle)="getCurrentNav($event)"></app-sidebar>
    </nav>
    <div class="content pl-0 main-content col-md-11" >
      <router-outlet #route="outlet"></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>
</div>
<ngx-loading-bar></ngx-loading-bar>
<block-ui></block-ui>
